// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"21f06b3d","691":"50c77825","702":"b83d9778","822":"465b0cca","914":"402f5bc6"}[chunkId] + ".chunk.js";
};